module.exports = __webpack_public_path__ + "static/media/privacy-policy-arrow.429b3a71.svg";